<template>
  <div :class="{ round: roundSlots }" class="roulette_container">
    <div class="roulette-inner">
      <div ref="roulette" class="roulette" style="display: none">
        <img :src="images.image0" class="rouletteN" alt="0" />
        <img :src="images.image1" class="rouletteN" alt="1" />
        <img :src="images.image2" class="rouletteN" alt="2" />
        <img :src="images.image3" class="rouletteN" alt="3" />
        <img :src="images.image4" class="rouletteN" alt="4" />
        <img :src="images.image5" class="rouletteN" alt="5" />
        <img :src="images.image6" class="rouletteN" alt="6" />
        <img :src="images.image7" class="rouletteN" alt="7" />
        <img :src="images.image8" class="rouletteN" alt="8" />
        <img :src="images.image9" class="rouletteN" alt="9" />
      </div>
    </div>
  </div>
</template>

<script>
import jquery from "jquery";

window.$ = jquery;
window.jQuery = jquery;
require("../../../../../assets/static/js/roulette.js");
import Image0 from "./images/0.png";
import Image1 from "./images/1.png";
import Image2 from "./images/2.png";
import Image3 from "./images/3.png";
import Image4 from "./images/4.png";
import Image5 from "./images/5.png";
import Image6 from "./images/6.png";
import Image7 from "./images/7.png";
import Image8 from "./images/8.png";
import Image9 from "./images/9.png";

export default {
  name: "VerticalSlotsMachine",
  props: {
    stopNumber: {
      type: Number,
      required: true
    },
    duration: {
      type: Number,
      default: 3
    },
    speed: {
      type: Number,
      default: 20
    },
    spin: {
      type: Boolean,
      default: false
    },
    roundSlots: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    images() {
      return {
        image0: Image0,
        image1: Image1,
        image2: Image2,
        image3: Image3,
        image4: Image4,
        image5: Image5,
        image6: Image6,
        image7: Image7,
        image8: Image8,
        image9: Image9
      };
    }
  },
  watch: {
    spin: {
      handler(value) {
        if (value) {
          jquery(this.$refs.roulette).roulette("start");
        } else {
          jquery(this.$refs.roulette).roulette("stop");
        }
      }
    }
  },
  mounted() {
    const context = this,
      options = {
        speed: this.speed,
        // duration: this.duration,
        stopImageNumber: this.stopNumber,
        startCallback() {
          context.$emit("start");
          console.log("start");
        },
        slowDownCallback() {
          context.$emit("slowDown");
          console.log("slowDown");
        },
        stopCallback() {
          context.$emit("stop");
          console.log("stop");
        }
      };

    jquery(this.$refs.roulette).roulette(options);
  }
};
</script>

<style lang="scss" scoped>
div.roulette {
}

div.roulette_container {
  /*background-color: rgb(253, 252, 253);*/
  width: 200px;
  height: 200px;
}

div.roulette_container.round {
  border-radius: 150px;
}

img.rouletteN {
  margin: auto;
  height: 180px;
  width: 180px;
}
</style>
